import { BookingType } from "../../features/Booking-Form/typings/booking-inputs";
import type { BookingScheduleInterface } from "../../features/Booking-Form/typings/booking.types";
import {
  hasVisitorDisplayData,
  resolveScheduleVisitors
} from "./ScheduleCalendar/ScheduleSelectionDialog/schedule-selection-visitor-edit.logic";

/** Calendar badge icon for visit-only rows and visitor place bookings with registration data. */
export function shouldShowVisitorScheduleIcon(schedule: BookingScheduleInterface): boolean {
  if (schedule.isVisitOnly === true) {
    return true;
  }
  return (schedule.visitorBookings?.length ?? 0) > 0;
}

function isWorkplaceSchedule(schedule: BookingScheduleInterface): boolean {
  return schedule.bookingType === BookingType.WORKPLACE || schedule.bookingType === "workplace";
}

/**
 * Visitor-managed workplace booking (visit-only, desk guest with consent lifecycle).
 * Legacy team externals (externalBooking only, external=false) are excluded.
 */
export function isVisitorManagedWorkplaceSchedule(schedule: BookingScheduleInterface): boolean {
  if (!isWorkplaceSchedule(schedule)) {
    return false;
  }
  if (schedule.isVisitOnly === true) {
    return true;
  }
  if (schedule.external === true) {
    return true;
  }
  return (schedule.visitorBookings?.length ?? 0) > 0;
}

/** Schedule selection dialog Visitor tab — visit-only, conference registrations, and bookPlace guests. */
export function shouldShowVisitorScheduleTab(schedule: BookingScheduleInterface): boolean {
  const hasVisitorCandidate =
    shouldShowVisitorScheduleIcon(schedule) ||
    (isWorkplaceSchedule(schedule) && schedule.external === true);
  if (!hasVisitorCandidate) {
    return false;
  }
  return resolveScheduleVisitors(schedule).some(hasVisitorDisplayData);
}

/** Calendar and popover primary label — visit-only and visitor desk (bookPlace) workplace bookings. */
export function shouldShowScheduleVisitorDisplayName(schedule: BookingScheduleInterface): boolean {
  return isVisitorManagedWorkplaceSchedule(schedule);
}
